module.exports = __webpack_public_path__ + "img/bottomImg.267c2d52.png";